import userTypes from "./user.types";

const INITIAL_STATE = {
  userInfo: "",
  isLoading: false,
  token: "",

  isConnected: false,
};

const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case userTypes.CLEAR_USER:
      return {
        ...INITIAL_STATE,
      };

    case userTypes.FETCH_USER_START:
      return {
        ...state,
        isLoading: true,
      };

    case userTypes.FETCH_USER_SUCCESS:
      return {
        ...state,
        userInfo: action.payload,
        isLoading: false,
      };

    case userTypes.SET_USER_TOKEN:
      return {
        ...state,
        token: action.payload,
      };

    case userTypes.SET_USER_IS_CONNECTED:
      return {
        ...state,
        isConnected: action.payload,
      };

    default:
      return state;
  }
};

export default userReducer;
